const CUSTOM_DISC = ['CRP', 'MIN'];

const PERMISSION = {
    COMPANY_ACCESS: 1,
    COMPANY_VIEW: 2,
    COMPANY_EDIT: 3,
    CUSTOMER_ACCESS: 4,
    CUSTOMER_VIEW: 5,
    CUSTOMER_EDIT: 6,
    DEPARTMENT_ACCESS: 7,
    DEPARTMENT_VIEW: 8,
    DEPARTMENT_EDIT: 9,
    ROLE_ACCESS: 10,
    ROLE_VIEW: 11,
    ROLE_EDIT: 12,
    STAFF_ACCESS: 13,
    STAFF_VIEW: 14,
    STAFF_EDIT: 15,
    STAFF_PROJECTS: 16,
    STAFF_ROLES: 17,
    STAFF_PASSWORD: 18,
    REPORTS: 19,
    PRICELIST_ACCESS: 20,
    PRICELIST_VIEW: 21,
    PRICELIST_EDIT: 22,
    QUOTE_ACCESS: 23,
    QUOTE_VIEW: 24,
    QUOTE_EDIT: 25,
    DOCUMENT_ACCESS: 26,
    DOCUMENT_VIEW: 27,
    DOCUMENT_EDIT: 28,
    SUPPLIER_MSSL: 29,
    FULL_ADMIN: 999, // No restrictions.
};

const SEARCH_OPTIONS = ['Starts with', 'Ends with', 'Anywhere in text'];
const SEARCH_AT_OPTIONS = [
    { text: 'Starts', value: 'start', icon: 'toggle_off' },
    { text: 'Ends', value: 'end', icon: 'toggle_on' },
    { text: 'Any', value: 'any', icon: 'link' },
    { text: 'Exact', value: 'exact', icon: 'edit_attributes' }
];

const STRIP_TYPES = ['Frame', 'Strip'];
const STRIP_DIVISION = ['Rubber', 'Sponge', 'I.G.M.'];
const STRIP_SIZE = [3, 6, 8, 10, 12, 15, 20, 25, 30, 35, 40, 45];

// Expose. Keep as module.exports for compatibility.
module.exports = {
    CUSTOM_DISC,
    PERMISSION,
    SEARCH_OPTIONS,
    SEARCH_AT_OPTIONS,
    STRIP_TYPES,
    STRIP_DIVISION,
    STRIP_SIZE
};



// WEBPACK FOOTER //
// ./src/util/Constants.js